import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import axios from "axios";
import { useProject } from "../ProjectContext.js";
import Sidebar from "../componenteExtra/SidebarSolicitante.js";
import Modal from "react-modal";
import { Toaster, toast } from "react-hot-toast";
import SessionManager from '../componenteExtra/SessionManager';

const IngresarSolicitud = () => {
  const navigate = useNavigate();
  const [actividades, setActividades] = useState([]);
  const [selectedRows, setSelectedRows] = useState({});
  const [grupoFiltro, setGrupoFiltro] = useState("Todos");
  const { projectData } = useProject();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedProcedimiento, setSelectedProcedimiento] = useState("");

  const token = localStorage.getItem("access_token");

  console.log("token", token);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/activities`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => setActividades(response.data))
      .catch((error) => console.error("Error fetching data: ", error));
  }, [token]);

  const toggleRow = (id) => {
    setSelectedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleDateChange = (id, date) => {
    const selectedDate = new Date(date);
    const currentDate = new Date().toISOString().split("T")[0];

    if (selectedDate.getUTCDay() === 0 || selectedDate.getUTCDay() === 6) {
        toast.error("No se puede seleccionar una fecha en fin de semana");
        return;
    }

    if (date < currentDate) {
        toast.error("La fecha de entrega no puede ser anterior a la fecha actual.");
        return;
    }

    // Verificar si la fecha de entrega de información es válida respecto a la fecha de término
    const actividadSeleccionada = actividades.find((activity) => activity.id === id);
    if (actividadSeleccionada && actividadSeleccionada.fechaTerminoActividad) {
        const maxEntregaDate = new Date(actividadSeleccionada.fechaTerminoActividad);
        maxEntregaDate.setDate(maxEntregaDate.getDate() - 5);

        if (selectedDate > maxEntregaDate) {
            toast.error("La fecha de entrega de información debe ser al menos 5 días antes de la fecha de término.");
            return;
        }
    }

    setActividades((currentActivities) =>
        currentActivities.map((activity) => {
            // Si la actividad está seleccionada y no tiene fecha, se asigna a todas
            if (selectedRows[activity.id] && !activity.fechaEntregaInformacion) {
                return { ...activity, fechaEntregaInformacion: date };
            }

            // Si la actividad ya tiene una fecha, solo se cambia la del ID seleccionado manualmente
            if (activity.id === id) {
                return { ...activity, fechaEntregaInformacion: date };
            }

            return activity;
        })
    );
};


const handleEndDateChange = (id, date) => {
  const selectedDate = new Date(date);
  const currentDate = new Date().toISOString().split("T")[0];

  if (selectedDate.getUTCDay() === 0 || selectedDate.getUTCDay() === 6) {
    toast.error("No se puede seleccionar una fecha en fin de semana");
    return;
  }

  if (date < currentDate) {
    toast.error("La fecha de término no puede ser anterior a la fecha actual.");
    return;
  }

  if (projectData && projectData.selectedDate) {
    const maxEndDate = new Date(
      new Date(projectData.selectedDate).setDate(
        new Date(projectData.selectedDate).getDate() - 3
      )
    );

    if (selectedDate > maxEndDate) {
      toast.error("La fecha de término debe ser al menos 3 días antes de la fecha de emisión final.");
      return;
    }
  }

  // Validar la restricción de al menos 5 días después de la entrega de información
  const actividadSeleccionada = actividades.find((activity) => activity.id === id);
  if (actividadSeleccionada) {
    const minEndDate = new Date(actividadSeleccionada.fechaEntregaInformacion);
    minEndDate.setDate(minEndDate.getDate() + 5);

    if (selectedDate < minEndDate) {
      toast.error("La fecha de término debe ser al menos 5 días después de la entrega de información.");
      return;
    }
  }

  // Si pasa todas las validaciones, actualizar las actividades
  setActividades((currentActivities) =>
    currentActivities.map((activity) => {
      // Si la actividad está seleccionada y no tiene fecha, se asigna a todas
      if (selectedRows[activity.id] && !activity.fechaTerminoActividad) {
        return { ...activity, fechaTerminoActividad: date };
      }

      // Si la actividad ya tiene una fecha, solo se cambia la del ID seleccionado manualmente
      if (activity.id === id) {
        return { ...activity, fechaTerminoActividad: date };
      }

      return activity;
    })
  );
};


  const handleContinue = async () => {
    if (!projectData || !projectData.selectedType) {
      toast.error("El tipo de solicitud no se ha seleccionado correctamente.");
      return;
    }

    const currentDate = new Date().toISOString().split("T")[0];
    const nombre_get = localStorage.getItem("nombre_get"); // Obtener el nombre del solicitante desde localStorage

    // Asegúrate de que el nombre del solicitante se obtuvo correctamente
    console.log("Nombre del solicitante:", nombre_get);

    const fechaEmision = projectData.selectedDate
      ? new Date(projectData.selectedDate).toISOString().slice(0, 10)
      : null;

    const selectedActivities = actividades
      .filter((activity) => selectedRows[activity.id])
      .map((activity) => ({
        codigo_proyecto: projectData.projectCode,
        nombre_proyecto: projectData.projectName,
        razon_social: projectData.holding,
        tipo_solicitud: projectData.selectedType,
        tipo_regulacion: projectData.regulacion,
        estado_asignaciones: 1,
        filial: projectData.businessName,
        encargado_auditoria: `${projectData.partnerInCharge1} ${projectData.partnerInCharge2}`,
        rubro_get: activity.rubro_get,
        nombre_actividad_get: activity.nombre_actividad_get,
        numero_grupo: activity.numero_grupo,
        jefe_grupo: activity.jefe_grupo,
        subrogante: activity.subrogante,
        fecha_entrega_informacion: activity.fechaEntregaInformacion
          ? new Date(activity.fechaEntregaInformacion)
              .toISOString()
              .slice(0, 10)
          : null,
        fecha_termino_senior_actividad: activity.fechaTerminoActividad
          ? new Date(activity.fechaTerminoActividad).toISOString().slice(0, 10)
          : null,
        staff_asignado: null,
        fecha_de_inicio: null,
        fecha_de_termino: null,
        fecha_estado_staff: null,
        fecha_inscripción_actividad: currentDate,
        horas_get: null,
        nombre_solicitante: nombre_get, // Se añade el nombre del solicitante desde localStorage
        fecha_emision: fechaEmision, // Se añade la fecha de emisión si existe
        fecha_corte_auditoria: projectData.cutOffDate,
        enlace_comentario: projectData.enlace
      }));

    // Verificar que el nombre del solicitante esté en el objeto antes de enviar
    console.log("Selected Activities:", selectedActivities);

    const allDatesFilled = selectedActivities.every(
      (activity) =>
        activity.fecha_entrega_informacion &&
        activity.fecha_entrega_informacion.trim() !== "" &&
        activity.fecha_termino_senior_actividad &&
        activity.fecha_termino_senior_actividad.trim() !== "",
    );

    if (!allDatesFilled) {
      toast.error(
        "Por favor ingrese todas las fechas requeridas para las actividades seleccionadas.",
      );
      return;
    }

    const toastId = toast.loading("Guardando actividades...");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/test_asignacion_get`,
        selectedActivities,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      console.log("Actividades asignadas con éxito", response);
      toast.dismiss(toastId);
      toast.success("Solicitud enviada correctamente");
      setTimeout(() => navigate("/menusolicitante"), 1500);
    } catch (error) {
      console.error("Error al asignar actividades", error);
      toast.dismiss(toastId);
      toast.error("Error al asignar actividades: " + error.message);
    }
  };

  const handleFiltroChange = (e) => {
    setGrupoFiltro(e.target.value);
  };

  const openModal = (procedimiento) => {
    setSelectedProcedimiento(procedimiento);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedProcedimiento("");
  };

  const actividadesFiltradas =
    grupoFiltro === "Todos"
      ? actividades
      : actividades.filter(
          (actividad) => actividad.numero_grupo === parseInt(grupoFiltro, 10),
        );

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
  <div className="main-panel">
    <h1>Actividades GET</h1>
    
    {/* Mostrar Fecha Corte Final */}
    {projectData.cutOffDate && (
      <h2 style={{ marginBottom: '10px', fontWeight: 'bold', color: '#4A4A4A' }}>
        Fecha Corte Final: {new Date(projectData.cutOffDate).toLocaleDateString()}
      </h2>
    )}

    {/* Mostrar Fecha de Emisión */}
    {projectData.selectedDate && (
      <h2 style={{ marginBottom: '20px', fontWeight: 'bold', color: '#4A4A4A' }}>
        Fecha de Emisión: {new Date(projectData.selectedDate).toLocaleDateString()}
      </h2>
    )}
          <div className="filter-section">
            <label htmlFor="grupoFiltro">Filtrar por Grupo: </label>
            <select
              id="grupoFiltro"
              value={grupoFiltro}
              onChange={handleFiltroChange}
            >
              <option value="Todos">Todos</option>
              <option value="1">Grupo 1</option>
              <option value="2">Grupo 2</option>
              <option value="3">Grupo 3</option>
              <option value="4">Grupo 4</option>
            </select>
          </div>
          <table className="activities-table">
            <thead>
              <tr>
                <th>Seleccionar</th>
                <th>Grupo</th>
                <th>Rubro</th>
                <th>Actividad</th>
                <th>Código GET</th>
                <th>Procedimiento</th>
                <th>Fecha de entrega de información</th>
                <th>Fecha de término actividad</th>
                <th>Jefe de Grupo</th>
                <th>Subrogante</th>
              </tr>
            </thead>
            <tbody>
              {actividadesFiltradas.map((actividad) => (
                <tr key={actividad.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows[actividad.id] || false}
                      onChange={() => toggleRow(actividad.id)}
                    />
                  </td>
                  <td>{actividad.numero_grupo}</td>
                  <td>{actividad.rubro_get}</td>
                  <td>{actividad.nombre_actividad_get}</td>
                  <td>{actividad.codigo_actividad_get}</td>
                  <td>
                    <button onClick={() => openModal(actividad.procedimiento)}>
                      Ver
                    </button>
                  </td>
                  <td>
                    <input
                      type="date"
                      name={`fechaEntrega${actividad.id}`}
                      disabled={!selectedRows[actividad.id]}
                      value={actividad.fechaEntregaInformacion || ""}
                      onChange={(e) => {
                        handleDateChange(actividad.id, e.target.value);
                        e.target.classList.toggle("highlight", e.target.value !== ""); // Agrega la clase si hay fecha
                      }}
                      className={actividad.fechaEntregaInformacion ? "highlight" : ""}
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      name={`fechaTermino${actividad.id}`}
                      disabled={!actividad.fechaEntregaInformacion}
                      value={actividad.fechaTerminoActividad || ""}
                      onChange={(e) => {
                        handleEndDateChange(actividad.id, e.target.value);
                        e.target.classList.toggle("highlight", e.target.value !== "");
                      }}
                      className={actividad.fechaTerminoActividad ? "highlight" : ""}
                    />
                  </td>
                  <td>{actividad.jefe_grupo}</td>
                  <td>{actividad.subrogante}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="continue-button" onClick={handleContinue}>
            Enviar solicitud
          </button>
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Procedimiento"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2>Procedimiento</h2>
        <p>{selectedProcedimiento}</p>
        <button onClick={closeModal} className="close-button">
          Cerrar
        </button>
      </Modal>
      <Toaster />
    </div>
  );
};

export default IngresarSolicitud;
